<script>
export default {
  data() {
    return {
      loading: true,
      blogs: null,
      totalPages: -1,
      total: -1,
      blogCategories: null,
      filter: {
        categories: null,
        page: 1,
      },
    };
  },

  mounted() {
    const promises = [this.getBlogs(), this.getBlogCategories()];

    Promise.all(promises).then(() => {
      this.loading = false;
    });
  },

  methods: {
    getBlogs() {
      const params = new URLSearchParams();

      if (this.filter && this.filter.categories) {
        params.append('categories', this.filter.categories);
      }

      if (this.filter.page && this.filter.page > 1) {
        params.append('page', this.filter.page);
      }

      const paramsString = decodeURIComponent(params.toString());

      return axios.get(`/api/blog?${paramsString}`).then((response) => {
        if (this.filter.page && this.filter.page > 1) {
          this.blogs = [...this.blogs, ...response.data.data];
        } else {
          this.blogs = response.data.data;
        }
        this.totalPages = response.data.totalpages;
        this.total = response.data.total;
      });
    },
    getBlogCategories() {
      return axios.get('/api/blog-categories').then((response) => {
        this.blogCategories = response.data;
      });
    },
    setCategoryFilter(cat) {
      if (this.filter.categories === cat.id) {
        this.filter = {
          categories: null,
          page: 1,
        };
        return;
      }
      this.filter = {
        categories: cat.id,
        page: 1,
      };
    },
    loadMore() {
      this.filter.page += 1;
    },
  },

  watch: {
    filter: {
      handler(newValue, oldValue) {
        this.loading = true;
        this.getBlogs().then(() => {
          this.loading = false;
        });
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div>
    <div class="flex md:justify-center mb-40 md:mb-80 items-center flex-wrap" v-if="blogCategories && blogCategories.length">
      <template v-for="cat in blogCategories">
        <button v-if="cat.count" @click.prevent="setCategoryFilter(cat)" :disabled="loading" :key="cat.id" :class="{ 'bg-black text-white': cat.id === filter.categories }" class="border-black py-4 px-8 border-2 duration-300 font-bold text-black hover:bg-black hover:text-white transition-colors" v-html="cat.name"></button>
      </template>
    </div>
    <transition-group tag="div" name="fade" mode="out-in" class="relative" style="min-height: 128px;">
      <div key="loading" v-if="loading" class="absolute inset-x-0 w-full flex items-center justify-center" style="top:40px">
        <transition name="fade">
          <img class="h-64 w-auto animate-spin duration-1000" src="images/loader.png" alt="loading" />
        </transition>
      </div>
      <div key="loaded" v-else-if="blogs && blogs.length" class="flex flex-col items-center">
        <transition-group name="fade" mode="out-in" tag="div" class="flex flex-wrap max-w-5xl w-full" style="margin: -20px;">
          <div :key="c.id" class="w-full md:w-1/2 mb-40" :class="index % 2 === 0 ? 'md:pr-20' : 'md:pl-20'" v-for="(c, index) in blogs">
            <blog-card :c="c"></blog-card>
          </div>
        </transition-group>
        <div class="md:mt-40" v-if="filter.page < totalPages">
          <button class="btn btn-sm btn-black" @click.prevent="loadMore">Meer laden</button>
        </div>
      </div>
      <div key="empty" v-else class="absolute inset-0 w-full h-full flex items-center justify-center">
        <span>Geen blogs gevonden</span>
      </div>
    </transition-group>
  </div>
</template>
